export enum Province {
	ANTWERP = 'ANTWERP',
	BRUSSELS = 'BRUSSELS',
	EAST_FLANDERS = 'EAST_FLANDERS',
	WEST_FLANDERS = 'WEST_FLANDERS',
	LIMBURG = 'LIMBURG',
	FLEMISH_BRABANT = 'FLEMISH_BRABANT',

	WALLOON_BRABANT = 'WALLOON_BRABANT',
	HAINAUT = 'HAINAUT',
	LIEGE = 'LIEGE',
	LUXEMBOURG = 'LUXEMBOURG',
	NAMUR = 'NAMUR',
}

export const PROVINCES: Province[] = [Province.ANTWERP, Province.BRUSSELS, Province.EAST_FLANDERS, Province.WEST_FLANDERS, Province.LIMBURG, Province.FLEMISH_BRABANT];

export const ALL_PROVINCES: Province[] = [
	Province.ANTWERP,
	Province.BRUSSELS,
	Province.EAST_FLANDERS,
	Province.WEST_FLANDERS,
	Province.LIMBURG,
	Province.FLEMISH_BRABANT,
	Province.WALLOON_BRABANT,
	Province.HAINAUT,
	Province.LIEGE,
	Province.LUXEMBOURG,
	Province.NAMUR,
];
